import clsx from "clsx";
import { Button, ButtonVariant, Text } from "@merge-api/merge-javascript-shared";
import { ChevronRight } from "lucide-react";

type Props = {
  children: React.ReactNode;
  onClick: () => void;
  isDisabled?: boolean;
  id?: string;
};

const MergeLinkCardButton = ({ children, onClick, isDisabled = false, id }: Props) => {
  return (
    <Button
      className="flex justify-between items-center gap-x-3 w-full py-3 pl-4 pr-3 shadow-none border border-gray-10"
      disabled={isDisabled}
      onClick={!isDisabled ? onClick : undefined}
      size="md"
      variant={ButtonVariant.TertiaryWhite}
      id={id}
    >
      <div className="text-left">
        <Text as="p" variant="md" className={clsx(isDisabled && "text-gray-40")}>
          {children}
        </Text>
      </div>
      <div>
        <ChevronRight size={16} className={clsx(isDisabled && "text-gray-40")} />
      </div>
    </Button>
  );
};

export default MergeLinkCardButton;
